import { Menu } from "@headlessui/react";
import { CogIcon } from "@heroicons/react/outline";
import { useState } from "react";
import AudioVideoSelector from "./AudioVideoSelector";
import DeviceBlockedPopup from "./DeviceBlockedPopup";
import RoundedIconButton from "./dumb-components/RoundedIconButton";

/**
 * - Strip the camera and microphone selector into a separate component
 * - Build check audio/video permission as a component
 */
function Join(props) {
  const microphoneAccessBlocked = props.microphoneAccessBlocked;
  const cameraAccessBlocked = props.cameraAccessBlocked;
  const cameraMuted = props.cameraMuted;
  const micMuted = props.micMuted;

  const handleJoinMeetingBtnClick = props.handleJoinMeetingBtnClick;
  const handleInputChanged = props.handleInputChanged;
  const username = props.username;
  const meeting = props.meeting;
  const audioVideoSelector = props.audioVideoSelector;

  const joining = props.joining;

  const DEADSIMPLESCREENSHARING_MODE = props.DEADSIMPLESCREENSHARING_MODE;

  return (
    <>
      <div className="flex items-center flex-col">
        <DeviceBlockedPopup
          microphoneAccessBlocked={microphoneAccessBlocked}
          cameraAccessBlocked={cameraAccessBlocked}
        />

        <div className="rounded-md shadow-sm border-2 border-gray-200 mt-4 p-4 w-11/12 sm:w-8/12 grid grid-rows-1 sm:grid-cols-2 gap-4 ">
          <div>
            {/* <h1 className="sm:hidden font-semibold mb-4 text-center">Join Meeting</h1> */}
            {audioVideoSelector}
          </div>

          <div className="flex flex-col items-center justify-center relative">
            <div>
              {/* <h1 className="hidden sm:block font-bold text-xl text-center mb-2">Join</h1> */}
              <hr />
            </div>

            <div className="space-y-4 mt-4 w-full">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <div className="mt-1 border-b border-gray-300 focus-within:border-indigo-600">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    className="block w-full border-0 border-b border-transparent bg-gray-50 focus:border-indigo-600 focus:ring-0 sm:text-sm"
                    placeholder="Enter your name"
                    onChange={handleInputChanged}
                  />
                </div>
              </div>

              {!joining ? (
                <button
                  onClick={handleJoinMeetingBtnClick}
                  type="button"
                  className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Join
                </button>
              ) : (
                <button
                  type="button"
                  className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <svg
                    role="status"
                    className="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  Requesting to Join
                </button>
              )}

              {/* <div className="flex justify-end sm:absolute right-0 top-0">
              <RoundedIconButton color="neutral" icon={<CogIcon />} />
            </div> */}
            </div>
          </div>
        </div>
      </div>

      {DEADSIMPLESCREENSHARING_MODE ? (
        <div class="mt-8">
          <div class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:px-8">
            <div class="overflow-hidden rounded-lg bg-gradient-to-r from-purple-500 to-green-100 shadow-xl lg:grid lg:grid-cols-2 lg:gap-4">
              <div class="px-6 pt-10 pb-12 sm:px-16 sm:pt-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
                <div class="lg:self-center">
                  <h2 class="text-2xl font-bold tracking-tight text-white sm:text-4xl">
                    <span class="block">Dead Simple Chat</span>
                    <span class="block text-3xl mt-4">Add Live Stream Chat,</span>
                    <span class="block text-3xl">Group Chat, 1-1 Chat to any</span>
                    <span class="block text-3xl"> App, Website or Virtual Event.</span>
                  </h2>
        
                  <p class="mt-4 text-xl font-semibold leading-6 text-white">
                    Pre-built Chat with Powerful SDK and Webhooks.
                  </p>
                  <a target="_blank" href="https://deadsimplechat.com?ref=deadsimplescreensharing" class="mt-8 inline-flex items-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-indigo-600 shadow hover:bg-indigo-50">Visit Dead Simple Chat</a>
                </div>
              </div>
              <div class="aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1 -mt-6">
                <img class=" transform rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-5" src="https://deadsimplechat.com/images/deadsimpleGroup-chat1.png" alt="App screenshot" />
              </div>
            </div>
          </div>
        </div>
        // <div className="mt-4">
        //   <div className="mx-auto px-4 py-16 sm:max-w-xl md:max-w-full md:px-24 lg:max-w-screen-xl lg:px-8 lg:py-20">
        //     <div className="row-gap-10 grid gap-5 lg:grid-cols-2">
        //       <div className="flex flex-col justify-center">
        //         <div className="mb-6 max-w-xl">
        //           <h2 className="mb-6 max-w-lg font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
        //             ⚡Try{" "}
        //             <a className="text-indigo-600" href="https://www.metered.ca/embed-video-chat">
        //               Metered Embed
        //             </a>
        //             <br className="hidden md:block" />
        //             <span className="relative px-1">
        //               <div className="bg-teal-accent-400 absolute inset-x-0 bottom-0 h-3 -skew-x-12 transform"></div>
        //               <span className="text-deep-purple-accent-400 relative inline-block">
        //                 to unlock powerful features
        //               </span>
        //             </span>
        //           </h2>
        //           <p className="text-base text-gray-700 md:text-lg">
        //             Signup for free Metered Embed account, to use the following features:
        //           </p>

        //           <a
        //             href="https://www.metered.ca/embed-video-chat"
        //             target="_blank"
        //             className="mt-4 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        //           >
        //             Learn More
        //           </a>
        //         </div>
        //         <p className="mb-4 text-sm font-bold uppercase tracking-widest">Features</p>
        //         <div className="grid space-y-3 sm:grid-cols-2 sm:gap-2 sm:space-y-0">
        //           <ul className="space-y-3">
        //             <li className="flex">
        //               <span className="mr-1">
        //                 <svg
        //                   className="text-deep-purple-accent-400 mt-px h-5 w-5"
        //                   stroke="currentColor"
        //                   viewBox="0 0 52 52"
        //                 >
        //                   <polygon
        //                     strokeWidth="4"
        //                     strokeLinecap="round"
        //                     strokeLinejoin="round"
        //                     fill="none"
        //                     points="29 13 14 29 25 29 23 39 38 23 27 23"
        //                   ></polygon>
        //                 </svg>
        //               </span>
        //               Custom and Fixed Meeting URL
        //             </li>
        //             <li className="flex">
        //               <span className="mr-1">
        //                 <svg
        //                   className="text-deep-purple-accent-400 mt-px h-5 w-5"
        //                   stroke="currentColor"
        //                   viewBox="0 0 52 52"
        //                 >
        //                   <polygon
        //                     strokeWidth="4"
        //                     strokeLinecap="round"
        //                     strokeLinejoin="round"
        //                     fill="none"
        //                     points="29 13 14 29 25 29 23 39 38 23 27 23"
        //                   ></polygon>
        //                 </svg>
        //               </span>
        //               Embed to your Website or App
        //             </li>
        //             <li className="flex">
        //               <span className="mr-1">
        //                 <svg
        //                   className="text-deep-purple-accent-400 mt-px h-5 w-5"
        //                   stroke="currentColor"
        //                   viewBox="0 0 52 52"
        //                 >
        //                   <polygon
        //                     strokeWidth="4"
        //                     strokeLinecap="round"
        //                     strokeLinejoin="round"
        //                     fill="none"
        //                     points="29 13 14 29 25 29 23 39 38 23 27 23"
        //                   ></polygon>
        //                 </svg>
        //               </span>
        //               Moderation and make participants view only.
        //             </li>
        //           </ul>
        //           <ul className="space-y-3">
        //             <li className="flex">
        //               <span className="mr-1">
        //                 <svg
        //                   className="text-deep-purple-accent-400 mt-px h-5 w-5"
        //                   stroke="currentColor"
        //                   viewBox="0 0 52 52"
        //                 >
        //                   <polygon
        //                     strokeWidth="4"
        //                     strokeLinecap="round"
        //                     strokeLinejoin="round"
        //                     fill="none"
        //                     points="29 13 14 29 25 29 23 39 38 23 27 23"
        //                   ></polygon>
        //                 </svg>
        //               </span>
        //               Custom Branding and Whitelable
        //             </li>
        //             <li className="flex">
        //               <span className="mr-1">
        //                 <svg
        //                   className="text-deep-purple-accent-400 mt-px h-5 w-5"
        //                   stroke="currentColor"
        //                   viewBox="0 0 52 52"
        //                 >
        //                   <polygon
        //                     strokeWidth="4"
        //                     strokeLinecap="round"
        //                     strokeLinejoin="round"
        //                     fill="none"
        //                     points="29 13 14 29 25 29 23 39 38 23 27 23"
        //                   ></polygon>
        //                 </svg>
        //               </span>
        //               Recording Meetings
        //             </li>
        //             <li className="flex">
        //               <span className="mr-1">
        //                 <svg
        //                   className="text-deep-purple-accent-400 mt-px h-5 w-5"
        //                   stroke="currentColor"
        //                   viewBox="0 0 52 52"
        //                 >
        //                   <polygon
        //                     strokeWidth="4"
        //                     strokeLinecap="round"
        //                     strokeLinejoin="round"
        //                     fill="none"
        //                     points="29 13 14 29 25 29 23 39 38 23 27 23"
        //                   ></polygon>
        //                 </svg>
        //               </span>
        //               Live Stream Meeting to Facebook Live/YouTube Live/Twitch etc.
        //             </li>
        //           </ul>
        //         </div>
        //       </div>
        //       <div>
        //         <img
        //           className="h-56 w-full sm:h-96"
        //           src="https://www.metered.ca/images/video_call_iframe.svg"
        //           alt=""
        //         />
        //       </div>
        //     </div>
        //   </div>
        // </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Join;
